// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "settlement.proto" (package "transaction", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message transaction.PersonalTransactionFields
 */
export interface PersonalTransactionFields {
    /**
     * @generated from protobuf field: uint32 amount = 1
     */
    amount: number;
    /**
     * @generated from protobuf field: uint32 currency = 2
     */
    currency: number;
    /**
     * @generated from protobuf field: optional uint32 sender = 3
     */
    sender?: number;
    /**
     * @generated from protobuf field: optional uint32 receiver = 4
     */
    receiver?: number;
    /**
     * @generated from protobuf field: optional uint32 category = 5
     */
    category?: number;
    /**
     * @generated from protobuf field: string date = 6
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 7
     */
    note: string;
    /**
     * @generated from protobuf field: uint32 receiver_currency = 8
     */
    receiverCurrency: number;
    /**
     * @generated from protobuf field: uint32 receiver_amount = 9
     */
    receiverAmount: number;
}
/**
 * @generated from protobuf message transaction.Settlement
 */
export interface Settlement {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: uint32 transaction_group = 2
     */
    transactionGroup: number;
    /**
     * @generated from protobuf field: uint32 amount = 3
     */
    amount: number;
    /**
     * @generated from protobuf field: string date = 4
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 5
     */
    note: string;
    /**
     * @generated from protobuf field: string payer = 6
     */
    payer: string;
    /**
     * @generated from protobuf field: string receiver = 7
     */
    receiver: string;
    /**
     * @generated from protobuf field: string created_by = 8
     */
    createdBy: string;
    /**
     * @generated from protobuf field: string proposed_by = 9
     */
    proposedBy: string;
    /**
     * @generated from protobuf field: bool completed = 10
     */
    completed: boolean;
    /**
     * @generated from protobuf field: optional uint32 own_transaction = 11
     */
    ownTransaction?: number;
}
/**
 * @generated from protobuf message transaction.GetAllSettlementsRequest
 */
export interface GetAllSettlementsRequest {
}
/**
 * @generated from protobuf message transaction.GetAllSettlementsResponse
 */
export interface GetAllSettlementsResponse {
    /**
     * @generated from protobuf field: repeated transaction.Settlement settlements = 1
     */
    settlements: Settlement[];
}
/**
 * @generated from protobuf message transaction.CreateSettlementRequest
 */
export interface CreateSettlementRequest {
    /**
     * @generated from protobuf field: uint32 transaction_group = 1
     */
    transactionGroup: number;
    /**
     * @generated from protobuf field: uint32 amount = 2
     */
    amount: number;
    /**
     * @generated from protobuf field: string date = 3
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 4
     */
    note: string;
    /**
     * @generated from protobuf field: string payer = 5
     */
    payer: string;
    /**
     * @generated from protobuf field: string receiver = 6
     */
    receiver: string;
    /**
     * @generated from protobuf field: optional transaction.PersonalTransactionFields own_transaction = 7
     */
    ownTransaction?: PersonalTransactionFields;
}
/**
 * @generated from protobuf message transaction.CreateSettlementResponse
 */
export interface CreateSettlementResponse {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.UpdateSettlementRequest
 */
export interface UpdateSettlementRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: uint32 amount = 2
     */
    amount: number;
    /**
     * @generated from protobuf field: string date = 3
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 4
     */
    note: string;
    /**
     * @generated from protobuf field: optional transaction.PersonalTransactionFields own_transaction = 5
     */
    ownTransaction?: PersonalTransactionFields;
}
/**
 * @generated from protobuf message transaction.UpdateSettlementResponse
 */
export interface UpdateSettlementResponse {
}
/**
 * @generated from protobuf message transaction.ConfirmSettlementRequest
 */
export interface ConfirmSettlementRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: optional transaction.PersonalTransactionFields own_transaction = 2
     */
    ownTransaction?: PersonalTransactionFields;
}
/**
 * @generated from protobuf message transaction.ConfirmSettlementResponse
 */
export interface ConfirmSettlementResponse {
}
/**
 * @generated from protobuf message transaction.DeleteSettlementRequest
 */
export interface DeleteSettlementRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.DeleteSettlementResponse
 */
export interface DeleteSettlementResponse {
}
/**
 * @generated from protobuf message transaction.RecordSettlementTransactionRequest
 */
export interface RecordSettlementTransactionRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: transaction.PersonalTransactionFields own_transaction = 2
     */
    ownTransaction?: PersonalTransactionFields;
}
/**
 * @generated from protobuf message transaction.RecordSettlementTransactionResponse
 */
export interface RecordSettlementTransactionResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class PersonalTransactionFields$Type extends MessageType<PersonalTransactionFields> {
    constructor() {
        super("transaction.PersonalTransactionFields", [
            { no: 1, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "sender", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "receiver", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "receiver_currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "receiver_amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PersonalTransactionFields>): PersonalTransactionFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.amount = 0;
        message.currency = 0;
        message.date = "";
        message.note = "";
        message.receiverCurrency = 0;
        message.receiverAmount = 0;
        if (value !== undefined)
            reflectionMergePartial<PersonalTransactionFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PersonalTransactionFields): PersonalTransactionFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 amount */ 1:
                    message.amount = reader.uint32();
                    break;
                case /* uint32 currency */ 2:
                    message.currency = reader.uint32();
                    break;
                case /* optional uint32 sender */ 3:
                    message.sender = reader.uint32();
                    break;
                case /* optional uint32 receiver */ 4:
                    message.receiver = reader.uint32();
                    break;
                case /* optional uint32 category */ 5:
                    message.category = reader.uint32();
                    break;
                case /* string date */ 6:
                    message.date = reader.string();
                    break;
                case /* string note */ 7:
                    message.note = reader.string();
                    break;
                case /* uint32 receiver_currency */ 8:
                    message.receiverCurrency = reader.uint32();
                    break;
                case /* uint32 receiver_amount */ 9:
                    message.receiverAmount = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PersonalTransactionFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 amount = 1; */
        if (message.amount !== 0)
            writer.tag(1, WireType.Varint).uint32(message.amount);
        /* uint32 currency = 2; */
        if (message.currency !== 0)
            writer.tag(2, WireType.Varint).uint32(message.currency);
        /* optional uint32 sender = 3; */
        if (message.sender !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.sender);
        /* optional uint32 receiver = 4; */
        if (message.receiver !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.receiver);
        /* optional uint32 category = 5; */
        if (message.category !== undefined)
            writer.tag(5, WireType.Varint).uint32(message.category);
        /* string date = 6; */
        if (message.date !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.date);
        /* string note = 7; */
        if (message.note !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.note);
        /* uint32 receiver_currency = 8; */
        if (message.receiverCurrency !== 0)
            writer.tag(8, WireType.Varint).uint32(message.receiverCurrency);
        /* uint32 receiver_amount = 9; */
        if (message.receiverAmount !== 0)
            writer.tag(9, WireType.Varint).uint32(message.receiverAmount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.PersonalTransactionFields
 */
export const PersonalTransactionFields = new PersonalTransactionFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Settlement$Type extends MessageType<Settlement> {
    constructor() {
        super("transaction.Settlement", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "transaction_group", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "payer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "receiver", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "proposed_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "completed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "own_transaction", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Settlement>): Settlement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.transactionGroup = 0;
        message.amount = 0;
        message.date = "";
        message.note = "";
        message.payer = "";
        message.receiver = "";
        message.createdBy = "";
        message.proposedBy = "";
        message.completed = false;
        if (value !== undefined)
            reflectionMergePartial<Settlement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Settlement): Settlement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* uint32 transaction_group */ 2:
                    message.transactionGroup = reader.uint32();
                    break;
                case /* uint32 amount */ 3:
                    message.amount = reader.uint32();
                    break;
                case /* string date */ 4:
                    message.date = reader.string();
                    break;
                case /* string note */ 5:
                    message.note = reader.string();
                    break;
                case /* string payer */ 6:
                    message.payer = reader.string();
                    break;
                case /* string receiver */ 7:
                    message.receiver = reader.string();
                    break;
                case /* string created_by */ 8:
                    message.createdBy = reader.string();
                    break;
                case /* string proposed_by */ 9:
                    message.proposedBy = reader.string();
                    break;
                case /* bool completed */ 10:
                    message.completed = reader.bool();
                    break;
                case /* optional uint32 own_transaction */ 11:
                    message.ownTransaction = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Settlement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* uint32 transaction_group = 2; */
        if (message.transactionGroup !== 0)
            writer.tag(2, WireType.Varint).uint32(message.transactionGroup);
        /* uint32 amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Varint).uint32(message.amount);
        /* string date = 4; */
        if (message.date !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.date);
        /* string note = 5; */
        if (message.note !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.note);
        /* string payer = 6; */
        if (message.payer !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.payer);
        /* string receiver = 7; */
        if (message.receiver !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.receiver);
        /* string created_by = 8; */
        if (message.createdBy !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdBy);
        /* string proposed_by = 9; */
        if (message.proposedBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.proposedBy);
        /* bool completed = 10; */
        if (message.completed !== false)
            writer.tag(10, WireType.Varint).bool(message.completed);
        /* optional uint32 own_transaction = 11; */
        if (message.ownTransaction !== undefined)
            writer.tag(11, WireType.Varint).uint32(message.ownTransaction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.Settlement
 */
export const Settlement = new Settlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllSettlementsRequest$Type extends MessageType<GetAllSettlementsRequest> {
    constructor() {
        super("transaction.GetAllSettlementsRequest", []);
    }
    create(value?: PartialMessage<GetAllSettlementsRequest>): GetAllSettlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllSettlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllSettlementsRequest): GetAllSettlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllSettlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllSettlementsRequest
 */
export const GetAllSettlementsRequest = new GetAllSettlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllSettlementsResponse$Type extends MessageType<GetAllSettlementsResponse> {
    constructor() {
        super("transaction.GetAllSettlementsResponse", [
            { no: 1, name: "settlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Settlement }
        ]);
    }
    create(value?: PartialMessage<GetAllSettlementsResponse>): GetAllSettlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.settlements = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllSettlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllSettlementsResponse): GetAllSettlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated transaction.Settlement settlements */ 1:
                    message.settlements.push(Settlement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllSettlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated transaction.Settlement settlements = 1; */
        for (let i = 0; i < message.settlements.length; i++)
            Settlement.internalBinaryWrite(message.settlements[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllSettlementsResponse
 */
export const GetAllSettlementsResponse = new GetAllSettlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSettlementRequest$Type extends MessageType<CreateSettlementRequest> {
    constructor() {
        super("transaction.CreateSettlementRequest", [
            { no: 1, name: "transaction_group", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "payer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "receiver", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "own_transaction", kind: "message", T: () => PersonalTransactionFields }
        ]);
    }
    create(value?: PartialMessage<CreateSettlementRequest>): CreateSettlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionGroup = 0;
        message.amount = 0;
        message.date = "";
        message.note = "";
        message.payer = "";
        message.receiver = "";
        if (value !== undefined)
            reflectionMergePartial<CreateSettlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSettlementRequest): CreateSettlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 transaction_group */ 1:
                    message.transactionGroup = reader.uint32();
                    break;
                case /* uint32 amount */ 2:
                    message.amount = reader.uint32();
                    break;
                case /* string date */ 3:
                    message.date = reader.string();
                    break;
                case /* string note */ 4:
                    message.note = reader.string();
                    break;
                case /* string payer */ 5:
                    message.payer = reader.string();
                    break;
                case /* string receiver */ 6:
                    message.receiver = reader.string();
                    break;
                case /* optional transaction.PersonalTransactionFields own_transaction */ 7:
                    message.ownTransaction = PersonalTransactionFields.internalBinaryRead(reader, reader.uint32(), options, message.ownTransaction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSettlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 transaction_group = 1; */
        if (message.transactionGroup !== 0)
            writer.tag(1, WireType.Varint).uint32(message.transactionGroup);
        /* uint32 amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Varint).uint32(message.amount);
        /* string date = 3; */
        if (message.date !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.date);
        /* string note = 4; */
        if (message.note !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.note);
        /* string payer = 5; */
        if (message.payer !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.payer);
        /* string receiver = 6; */
        if (message.receiver !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.receiver);
        /* optional transaction.PersonalTransactionFields own_transaction = 7; */
        if (message.ownTransaction)
            PersonalTransactionFields.internalBinaryWrite(message.ownTransaction, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateSettlementRequest
 */
export const CreateSettlementRequest = new CreateSettlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSettlementResponse$Type extends MessageType<CreateSettlementResponse> {
    constructor() {
        super("transaction.CreateSettlementResponse", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateSettlementResponse>): CreateSettlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateSettlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSettlementResponse): CreateSettlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSettlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateSettlementResponse
 */
export const CreateSettlementResponse = new CreateSettlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSettlementRequest$Type extends MessageType<UpdateSettlementRequest> {
    constructor() {
        super("transaction.UpdateSettlementRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "own_transaction", kind: "message", T: () => PersonalTransactionFields }
        ]);
    }
    create(value?: PartialMessage<UpdateSettlementRequest>): UpdateSettlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.amount = 0;
        message.date = "";
        message.note = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateSettlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSettlementRequest): UpdateSettlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* uint32 amount */ 2:
                    message.amount = reader.uint32();
                    break;
                case /* string date */ 3:
                    message.date = reader.string();
                    break;
                case /* string note */ 4:
                    message.note = reader.string();
                    break;
                case /* optional transaction.PersonalTransactionFields own_transaction */ 5:
                    message.ownTransaction = PersonalTransactionFields.internalBinaryRead(reader, reader.uint32(), options, message.ownTransaction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSettlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* uint32 amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Varint).uint32(message.amount);
        /* string date = 3; */
        if (message.date !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.date);
        /* string note = 4; */
        if (message.note !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.note);
        /* optional transaction.PersonalTransactionFields own_transaction = 5; */
        if (message.ownTransaction)
            PersonalTransactionFields.internalBinaryWrite(message.ownTransaction, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateSettlementRequest
 */
export const UpdateSettlementRequest = new UpdateSettlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSettlementResponse$Type extends MessageType<UpdateSettlementResponse> {
    constructor() {
        super("transaction.UpdateSettlementResponse", []);
    }
    create(value?: PartialMessage<UpdateSettlementResponse>): UpdateSettlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSettlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSettlementResponse): UpdateSettlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSettlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateSettlementResponse
 */
export const UpdateSettlementResponse = new UpdateSettlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmSettlementRequest$Type extends MessageType<ConfirmSettlementRequest> {
    constructor() {
        super("transaction.ConfirmSettlementRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "own_transaction", kind: "message", T: () => PersonalTransactionFields }
        ]);
    }
    create(value?: PartialMessage<ConfirmSettlementRequest>): ConfirmSettlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<ConfirmSettlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmSettlementRequest): ConfirmSettlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* optional transaction.PersonalTransactionFields own_transaction */ 2:
                    message.ownTransaction = PersonalTransactionFields.internalBinaryRead(reader, reader.uint32(), options, message.ownTransaction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmSettlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* optional transaction.PersonalTransactionFields own_transaction = 2; */
        if (message.ownTransaction)
            PersonalTransactionFields.internalBinaryWrite(message.ownTransaction, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.ConfirmSettlementRequest
 */
export const ConfirmSettlementRequest = new ConfirmSettlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmSettlementResponse$Type extends MessageType<ConfirmSettlementResponse> {
    constructor() {
        super("transaction.ConfirmSettlementResponse", []);
    }
    create(value?: PartialMessage<ConfirmSettlementResponse>): ConfirmSettlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConfirmSettlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmSettlementResponse): ConfirmSettlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmSettlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.ConfirmSettlementResponse
 */
export const ConfirmSettlementResponse = new ConfirmSettlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSettlementRequest$Type extends MessageType<DeleteSettlementRequest> {
    constructor() {
        super("transaction.DeleteSettlementRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteSettlementRequest>): DeleteSettlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteSettlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSettlementRequest): DeleteSettlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSettlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteSettlementRequest
 */
export const DeleteSettlementRequest = new DeleteSettlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSettlementResponse$Type extends MessageType<DeleteSettlementResponse> {
    constructor() {
        super("transaction.DeleteSettlementResponse", []);
    }
    create(value?: PartialMessage<DeleteSettlementResponse>): DeleteSettlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteSettlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSettlementResponse): DeleteSettlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSettlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteSettlementResponse
 */
export const DeleteSettlementResponse = new DeleteSettlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordSettlementTransactionRequest$Type extends MessageType<RecordSettlementTransactionRequest> {
    constructor() {
        super("transaction.RecordSettlementTransactionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "own_transaction", kind: "message", T: () => PersonalTransactionFields }
        ]);
    }
    create(value?: PartialMessage<RecordSettlementTransactionRequest>): RecordSettlementTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<RecordSettlementTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RecordSettlementTransactionRequest): RecordSettlementTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* transaction.PersonalTransactionFields own_transaction */ 2:
                    message.ownTransaction = PersonalTransactionFields.internalBinaryRead(reader, reader.uint32(), options, message.ownTransaction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RecordSettlementTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* transaction.PersonalTransactionFields own_transaction = 2; */
        if (message.ownTransaction)
            PersonalTransactionFields.internalBinaryWrite(message.ownTransaction, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.RecordSettlementTransactionRequest
 */
export const RecordSettlementTransactionRequest = new RecordSettlementTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordSettlementTransactionResponse$Type extends MessageType<RecordSettlementTransactionResponse> {
    constructor() {
        super("transaction.RecordSettlementTransactionResponse", []);
    }
    create(value?: PartialMessage<RecordSettlementTransactionResponse>): RecordSettlementTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RecordSettlementTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RecordSettlementTransactionResponse): RecordSettlementTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RecordSettlementTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.RecordSettlementTransactionResponse
 */
export const RecordSettlementTransactionResponse = new RecordSettlementTransactionResponse$Type();
/**
 * @generated ServiceType for protobuf service transaction.SettlementService
 */
export const SettlementService = new ServiceType("transaction.SettlementService", [
    { name: "GetAllSettlements", options: {}, I: GetAllSettlementsRequest, O: GetAllSettlementsResponse },
    { name: "CreateSettlement", options: {}, I: CreateSettlementRequest, O: CreateSettlementResponse },
    { name: "UpdateSettlement", options: {}, I: UpdateSettlementRequest, O: UpdateSettlementResponse },
    { name: "ConfirmSettlement", options: {}, I: ConfirmSettlementRequest, O: ConfirmSettlementResponse },
    { name: "DeleteSettlement", options: {}, I: DeleteSettlementRequest, O: DeleteSettlementResponse },
    { name: "RecordSettlementTransaction", options: {}, I: RecordSettlementTransactionRequest, O: RecordSettlementTransactionResponse }
]);
